import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import CombinedHeader from "./CombinedHeader";
const Layout = () => {
  return (
    <>
      <CombinedHeader/> 
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
